import {
  AccountTransactions,
  getAccountTransactions,
} from "../../../api/services";
import { useQuery } from "react-query";
import { usePagination } from "../../../hooks";

const PAGE_SIZE = 20;

export interface useAccountTransactionsResult {
  page: number;
  setPage: (page: number) => void;
  status: "loading" | "error" | "success";
  error: null | unknown;
  isFetching: boolean;
  data: AccountTransactions | undefined;
}

export const useAccountTransactions = (accountNumber: string) => {
  const { setPage, page } = usePagination(
    `accounts/${accountNumber}/transactions`,
  );

  const { isFetching, status, error, data } = useQuery(
    ["accounts/transactions", { page, size: PAGE_SIZE, accountNumber }],
    getAccountTransactions,
  );

  return {
    //Pagination Handlers
    page,
    setPage,
    pageSize: PAGE_SIZE,
    // Request Handlers
    status,
    isFetching,
    error,
    data: data?.results,
    count: data?.totalCount,
  };
};
